export default __webpack_public_path__ + "static/trio-f594aea2fda55ffb9b6bd9c2090c02f1.svg";